import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { colors } from "@material-ui/core";
import { styleHA, stylRo } from "./BodyItems";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
    },
}));


export default function SubRowsAccounts(props) {
    const { row
    } = props;
    return (
        <TableRow>

            <TableCell
                colSpan={7}
                sx={{
                    padding: "0px 0px !important",
                    backgroundColor: "#fafafa",
                    fontWeight: "bold"
                }}
            >
                {[1, 2, 3, 4].includes(row?.type) && row.items?.length > 0 &&
                    <TableContainer
                        component={Paper}
                        elevation={0}
                        style={{direction:"rtl"}}
                        sx={{
                            width: "88%",
                            marginRight: "auto",
                            border: "1px solid #dedede",
                            borderRadius: "4px",
                            overflow: "hidden",
                            
                        }}
                    >

                        <Table
                            size="small"
                            sx={{
                                tableLayout: "fixed",

                                "& th": {
                                    backgroundColor: "#f8f8f8",
                                    fontSize: "12px",
                                    fontWeight: "bold",
                                    padding: "0px 0px",
                                    borderBottom: "1px solid #aaa",
                                },

                                "& td": {
                                    fontSize: "12px",
                                    padding: "0px 0px",
                                    fontWeight: "bold",
                                    borderBottom: "1px dotted #d5d5d5",
                                },

                                "& tr:last-child td": {
                                    borderBottom: 0,
                                },

                                "@media print": {
                                    "& th": {
                                        fontSize: "12px",
                                        padding: "0px 0px",
                                        fontWeight: "bold",

                                    },

                                    "& td": {
                                        fontSize: "10px",
                                        fontWeight: "bold",
                                        padding: "0px 0px",
                                    },
                                },
                            }}
                        >

                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ ...styleHA, backgroundColor: colors.blue[200], width: "10%" }}>
                                        no
                                    </TableCell>

                                    <TableCell style={{ ...styleHA, backgroundColor: colors.blue[200], width: "50%" }}>
                                        اسم الصنف
                                    </TableCell>

                                    <TableCell style={{ ...styleHA, backgroundColor: colors.blue[200], width: "20%" }}
                                        align="center"
                                        sx={{ width: "20%" }}
                                    >
                                        الكمية
                                    </TableCell>

                                    <TableCell style={{ ...styleHA, backgroundColor: colors.blue[200], width: "20%" }}
                                        align="left"
                                        sx={{ width: "20%" }}
                                    >
                                        السعر
                                    </TableCell>

                                </TableRow>
                            </TableHead>

                            {row.items.map((row, i) => (
                                <TableBody>

                                    <TableRow>
                                    <TableCell style={{ ...stylRo }}>
                                            {i+1}
                                        </TableCell>
                                        <TableCell style={{ ...stylRo }}>
                                            {row.ItemName}
                                        </TableCell>

                                        <TableCell align="center" style={{ ...stylRo }}>
                                            {row.Qty?.toFixed(2)}
                                        </TableCell>

                                        <TableCell align="left" style={{ ...stylRo }}>
                                            {row.price?.toFixed(2)}
                                        </TableCell>

                                    </TableRow>

                                </TableBody>
                            ))}

                        </Table>

                    </TableContainer>
                }

            </TableCell>

        </TableRow>
    );
}
